import axios from 'axios';
import ModelApi from './ModelApiService';
const axiosInstance = axios.create();

const ModelApiService = new ModelApi(axiosInstance);

export { ModelApiService };

